/** Header carrying the project write key on every ingest request. */
export const API_KEY_HEADER = "x-watchover-key";

/** Header set when the body is gzip-compressed by the SDK (CompressionStream). */
export const ENCODING_HEADER = "x-watchover-encoding";

/** The ingest collector endpoint path. */
export const INGEST_PATH = "/v1/ingest";

/** localStorage / cookie keys used by the SDK on the host page. */
export const STORAGE_KEYS = {
  visitorId: "wo_vid",
  session: "wo_ses",
  userId: "wo_uid",
} as const;

/** Default tuning the SDK falls back to when the customer overrides nothing. */
export const SDK_DEFAULTS = {
  /** Flush the in-memory buffer at most this often (ms). */
  flushIntervalMs: 5000,
  /** Force a flush once the buffer reaches this many events. */
  maxBatchEvents: 100,
  /** Force a flush once the buffer's estimated size crosses this (bytes). */
  maxBatchBytes: 64 * 1024,
  /** Session rotates after this much inactivity (ms). Matches server default. */
  sessionTimeoutMs: 30 * 60 * 1000,
  /** Record at most this fraction of sessions (1 = everyone). */
  sampleRate: 1,
  /** Replay frames are themselves throttled by rrweb; this caps emit cadence. */
  replayFlushMs: 2000,
} as const;

/** rrweb event type ids we care about server-side (mirrors rrweb's enum). */
export const RRWEB_EVENT = {
  DomContentLoaded: 0,
  Load: 1,
  FullSnapshot: 2,
  IncrementalSnapshot: 3,
  Meta: 4,
  Custom: 5,
  Plugin: 6,
} as const;

export const SDK_VERSION = "0.1.0";
